import React, { Component } from 'react'
import DevExpressDataGrid from 'components/inheritComponent/devexpressdatagrid'
import { Card } from 'react-bootstrap'

class RiwayatTransaksi extends Component {
  constructor(props) {
    super(props)

    this.state = {}

    this.dataGridRef = React.createRef()

    this.dataRiwayatTransaksi = []

    this.columns = [
      {
        dataField: 'tipeTransaksi',
        caption: 'Tipe Transaksi',
      },
      {
        dataField: 'keterangan',
        caption: 'Keterangan',
        width: '200px',
      },
      {
        dataField: 'tanggalTransaksi',
        caption: 'Tanggal Transaksi',
        dataType: 'date',
        format: 'dd MM yyyy',
      },
      {
        dataField: 'tanggalAktiva',
        caption: 'Tanggal Aktiva',
        dataType: 'date',
        format: 'dd MM yyyy',
      },
      {
        dataField: 'nilaiAktivaBersih',
        caption: 'Nilai Aktiva Bersih',
        dataType: 'number',
        format: '#,##0.0000',
        alignment: 'right',
      },
      {
        dataField: 'unitTransaksi',
        caption: 'Unit Transaksi',
        dataType: 'number',
        format: '#,##0.0000',
        alignment: 'right',
      },
      {
        dataField: 'nominalTransaksi',
        caption: 'Nominal Transaksi',
        dataType: 'number',
        format: 'Rp #,##0.00',
        alignment: 'right',
      },
      {
        dataField: 'statusTransaksi',
        caption: 'Status Transaksi',
      },
    ]
  }

  onToolbarPreparing = (e) => {
    e.toolbarOptions.items.unshift({
      location: 'after',
      widget: 'dxButton',
      options: {
        text: 'Cetak',
        elementAttr: { class: 'bg-button-add-dapen-default' },
        onClick: (e) => {
          console.log(e)
        },
      },
    })
  }

  retrieveData = (data) => {
    if (data) {
      let dataRiwayatTransaksi = data

      this.dataRiwayatTransaksi = dataRiwayatTransaksi.map((item, index) => {
        return {
          ...item,
          id: index + 1,
        }
      })
      this.forceRefresh()
    }
  }

  loadDummy = () => {
    return this.dataRiwayatTransaksi
  }

  forceRefresh = () => {
    this.dataGridRef.current.forceRefresh(true)
  }

  render() {
    return (
      <React.Fragment>
        <Card style={{ height: '965px' }}>
          <Card.Body
            style={{
              paddingTop: '12px',
              paddingRight: '16px',
              paddingBottom: '12px',
              paddingLeft: '16px',
            }}
          >
            <span style={{ fontWeight: 'bold', fontSize: '20px' }}>
              Riwayat Transaksi
            </span>
            <DevExpressDataGrid
              ref={this.dataGridRef}
              loadAPI={`-`}
              insertAPI="-"
              updateAPI="-"
              deleteAPI="-"
              backendserver={process.env.REACT_APP_BACKEND_CORE}
              useArraySource={true}
              ArraySourceData={this.loadDummy}
              allowAdding={false}
              allowDeleting={false}
              allowUpdating={false}
              height={'869px'}
              exportExcel={false}
              exportFileName={'Pengajuan Peserta Pensiun Ditunda'}
              allowExportSelectedData={false}
              showBorders={false}
              paging={false}
              defaultPageSize={5}
              popupTitle={'Pengajuan Peserta Pensiun Ditunda'}
              popupWidth={700}
              popupHeight={500}
              popupFormLabelLocation="left"
              popupFormMinColWidth={300}
              popupFormColCount={3}
              ColumnChooser={false}
              ColumnFixing={false}
              FilterRow={false}
              ColumnConfiguration={this.columns}
              // onToolbarPreparing={this.onToolbarPreparing}
              store={this.props.store}
            />
          </Card.Body>
        </Card>
      </React.Fragment>
    )
  }
}

export default RiwayatTransaksi
